var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyAdminNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.75C21.075 7.75 22.7375 6.075 22.7375 4C22.7375 1.925 21.075 0.25 19 0.25C16.925 0.25 15.25 1.925 15.25 4C15.25 6.075 16.925 7.75 19 7.75ZM9 7.75C11.075 7.75 12.7375 6.075 12.7375 4C12.7375 1.925 11.075 0.25 9 0.25C6.925 0.25 5.25 1.925 5.25 4C5.25 6.075 6.925 7.75 9 7.75ZM9 10.25C6.0875 10.25 0.25 11.7125 0.25 14.625V17.75H17.75V14.625C17.75 11.7125 11.9125 10.25 9 10.25ZM19 10.25C18.6375 10.25 18.225 10.275 17.7875 10.3125C19.2375 11.3625 20.25 12.775 20.25 14.625V17.75H27.75V14.625C27.75 11.7125 21.9125 10.25 19 10.25Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyAdminNew);
export default __webpack_public_path__ + "static/media/company-admin-new.2485b7a8.svg";
export { ForwardRef as ReactComponent };